export default "__VITE_ASSET__Ce$t9vcX__"